/*
 * @Descripttion:
 * @Author: DXV-RGWU-TUFH-RFCY-IEGMYY
 * @Date: 2020-07-06 12:17:06
 * @LastEditors: DXV-RGWU-TUFH-RFCY-IEGMYY
 * @LastEditTime: 2023-05-24 14:54:28
 */
import {
  get,
  post
} from '../index'
export default {
  // 登录
  login (querys) {
    return post('massage/admin/Admin/login', querys)
  },
  // 登录是否需要输入验证码
  authPhone (querys) {
    return get('massage/admin/Admin/authPhone', querys)
  },
  // 获取验证码
  sendAuthCode (querys) {
    return post('massage/admin/Admin/sendAuthCode', querys)
  },
  // 配置信息
  getConfig (querys) {
    return get('massage/admin/Admin/getConfig', querys)
  },
  // 获取权限设置
  getSaasAuth (querys) {
    return get('massage/admin/AdminSetting/getSaasAuth', querys)
  },
  // 清除缓存
  clearCache () {
    return get('admin/admin/config/clear')
  },
  // 修改自己的密码
  updatePasswd (querys) {
    return post('massage/admin/AdminSetting/updatePass', querys)
  },
  // 获取w7底部信息
  getW7TmpV2 (querys) {
    return get('massage/admin/Admin/getW7TmpV2', querys)
  },
  // 基本信息
  returnAdmin () {
    return get('card/Admin/returnAdmin')
  },
  // 是否为微擎版，还是为独立版
  getIsWeiVersion () {
    return get('agent/admin/isWe7')
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/base.js